/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { motion } from "framer-motion";
import listImage from "static/mallpie/list3.png";
import { container } from "styles";
import { tabandmo } from "styles/media";

const Section4 = () => {
  const section4Style = css`
    padding: 40px 0;
    .box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 80px;
      .text {
        .title {
          font-size: 32px;
          font-style: normal;
          font-weight: 800;
          line-height: 48px;
        }
        .desc {
          margin-top: 20px;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 30px;
          opacity: 0.6;
        }
      }
      .img {
        width: 432px;
        img {
          width: 100%;
        }
      }
    }
    ${tabandmo} {
      padding: 30px 0;
      .box {
        display: flex;
        flex-direction: column-reverse;
        align-items: start;
        padding: 0 20px;
        .text {
          margin-top: 14px;
          .title {
            font-size: 22px;
            font-style: normal;
            font-weight: 700;
            line-height: 28px;
          }
          .desc {
            margin-top: 15px;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            opacity: 0.6;
          }
        }
        .img {
          width: 100%;
          margin: 0 auto;
        }
      }
    }
  `;

  return (
    <div css={section4Style}>
      <div css={container}>
        <motion.div
          className="box"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            offscreen: {
              y: 100,
              opacity: 0,
            },
            onscreen: {
              y: 0,
              opacity: 1,
              transition: {
                delay: 0.3,
                duration: 0.3,
              },
            },
          }}
        >
          <div className="text">
            <div className="title">
              최저가 · 무료배송 혜택으로
              <br />
              확실한 수익 실현
            </div>
            <div className="desc">
              폐쇄적 유통 구조로 최저가보다 더 저렴한 최저가,
              <br />
              조건 없는 무료 배송 혜택으로 수익 실현이 더 쉬워집니다. <br />
              고정된 비율이 아닌 상품 입점 수수료를 기준으로
              <br />
              평균 4~8% 수익금이 책정되어 있습니다.
            </div>
          </div>
          <div className="img">
            <img src={listImage} alt="list" title="list" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Section4;
